import { netural400 } from "../../constants/color";
import CustomLabel from "../shared/label/custom-label.component";

const ShippingAddressSection = ({ shippingAddress, name }) => {
  const { streetName, cityName, stateAndZipCode, country } = shippingAddress;
  return (
    <div style={{ marginTop: "3%" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <CustomLabel style={{ fontWeight: "600", fontSize: "20px" }}>
          Shipping address
        </CustomLabel>
      </div>
      <div style={{ marginTop: "3%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "16px",
            }}
          >
            {name}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "16px",
            }}
          >
            {streetName}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "16px",
            }}
          >
            {cityName} {stateAndZipCode}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "16px",
            }}
          >
            {country}
          </CustomLabel>
        </div>
      </div>
    </div>
  );
};

export default ShippingAddressSection;
